/* eslint-disable import/no-extraneous-dependencies */
import { isEmpty, cloneDeep, has } from 'lodash'
import setorService from '@/services/setor'
import { compareTextLettersOnly } from '@/core/utils/comparatorUtils'
import { COMMON_STATUS } from '@/strings'

export const SET_SETORES = 'SET_SETORES'
export const SET_SETOR = 'SET_SETOR'
export const SET_FILTRO = 'SET_FILTRO'
export const RESET_SETOR = 'RESET_SETOR'
export const SET_EXAMES_SETOR = 'SET_EXAMES_SETOR'
export const SET_EXPORT_DADOS_PGR = 'SET_EXPORT_DADOS_PGR'
export const RESET_EXPORT_DADOS_PGR = 'RESET_EXPORT_DADOS_PGR'

const defaultSetor = {
  name: '',
  description: '',
  perigos: '',
  agente_fator_riscos: '',
  consequencia_riscos: '',
  descricao_epis: '',
  descricao_epcs: '',
  riscos: [],
  exames: [],
  funcoes: [],
  periculosidade: '',
  insalubridade: '',
  nocividade: '',
}

const state = {
  setor: cloneDeep(defaultSetor),
  busca: {
    setores: [],
    filtro: {
      name: '',
    },
  },
}

const mutations = {
  [RESET_SETOR]: state => {
    state.setor = cloneDeep(defaultSetor)
  },
  [SET_SETORES]: (state, setores) => {
    state.busca.setores = setores
  },
  [SET_EXAMES_SETOR]: (state, exames) => {
    state.setor.exames = exames
  },
  [SET_SETOR]: (state, payload) => {
    state.setor.name = payload.nome
    state.setor.description = payload.descricao
    state.setor.id = payload.id_setor
    state.setor.perigos = payload.perigos
    state.setor.agente_fator_riscos = payload.agente_fator_riscos
    state.setor.consequencia_riscos = payload.consequencia_riscos
    state.setor.descricao_epis = payload.descricao_epis
    state.setor.descricao_epcs = payload.descricao_epcs
    state.setor.riscos = payload.riscos.map(r => ({ value: r.id_risco, label: r.nome, data: r.data }))
    state.setor.funcoes = payload.funcoes.map(r => r.id)
    state.setor.exames = payload.exames.map(r => ({
      value: r.id_exame,
      label: r.nome,
      validade: r.validade,
      tipos: r.tipos,
    }))
    // Exames should be disabled, Ex: only avaliação clinica
    state.setor.exames.filter(e => e.value === 1).forEach(e => (e.disabled = true))
    state.setor.isActive = payload.status
    state.setor.periculosidade = payload.periculosidade
    state.setor.insalubridade = payload.insalubridade
    state.setor.nocividade = payload.nocividade
  },
  [SET_FILTRO](state, filtro) {
    for (const key in filtro) {
      if (has(filtro, key)) {
        state.busca.filtro[key] = filtro[key]
      }
    }
  },
}

const getters = {
  setores: state => state.busca.setores,
  itemsFiltered: state => {
    let setoresFiltered = state.busca.setores

    const setorToSearch = state.busca.filtro.name

    if (!isEmpty(setorToSearch)) {
      setoresFiltered = setoresFiltered.filter(f => compareTextLettersOnly(f.name, setorToSearch))
    }

    return setoresFiltered
  },
  getFiltro: state => state.busca.filtro,
  modelForEdit: state => state.setor,
  isEmptyList: state => isEmpty(state.busca.setores),
}

const actions = {
  async search({ commit }, { idEmpresa }) {
    const response = await setorService.searchSetores(idEmpresa)
    commit(SET_SETORES, response.data)
  },
  async save({ commit }, { idEmpresa, model }) {
    model.status = COMMON_STATUS.ATIVA
    await setorService.save(model, idEmpresa)
    await commit(RESET_SETOR)
  },
  async loadById({ commit }, { id }) {
    const response = await setorService.searchSetor(id)
    await commit(SET_SETOR, response.data)
  },
  async updateStatus({}, { id, status }) {
    return setorService.updateStatus(id, status)
  },
  async exportRiscos({}, { riscos, idsModule }) {
    await setorService.exportRiscos({ riscos, idsSetores: idsModule })
  },
  async exportDadosPgr({}, { idsSetores, dadosPgr }) {
    await setorService.exportDadosPgr({ idsSetores, dadosPgr })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
